/* src/app/forms/payments/payments.component.scss */
.mat-mdc-tab-body.mat-tab-body-active {
  height: 60vh;
}
.block {
  animation: 1s fadeIn;
  animation-fill-mode: forwards;
  opacity: 0;
  animation: fadeIn 10s;
  animation-delay: 40s;
  animation-fill-mode: forwards;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.content {
  padding: 5px;
  height: calc(100% - 48px);
}
.mktplace {
  overflow: auto;
  height: 100%;
}
.view-component {
  border: 1px solid rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
  margin: 0px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.gridclass {
  height: 100%;
  width: 100%;
  position: absolute;
}
.mat-tab-body-content {
  height: auto !important;
}
.tabcontent {
  height: 100%;
  overflow-y: auto;
}
.cardcontent {
  height: 25%;
}
.hl {
  border-top: 1px solid gray;
  width: 100%;
  margin-top: 30px;
  margin-top: 20px;
  height: 1%;
}
.mat-mdc-tab-group {
  height: 100%;
}
:host ::ng-deep .custom-tabs {
}
:host ::ng-deep .custom-tabs .mat-tab-body-wrapper {
  height: 100%;
}
.transformimage {
  transform: scale(1.5);
}
.title {
  width: 100%;
  padding: 6px;
  text-align: right;
  font-size: 20px;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
/*# sourceMappingURL=payments.component.css.map */
